import { render, staticRenderFns } from "./legendItem.vue?vue&type=template&id=28e3774a&scoped=true"
import script from "./legendItem.vue?vue&type=script&lang=js"
export * from "./legendItem.vue?vue&type=script&lang=js"
import style0 from "./legendItem.vue?vue&type=style&index=0&id=28e3774a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3774a",
  null
  
)

export default component.exports